import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initI18n } from './i18n/config';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import registerServiceWorker from './registerServiceWorker';

const start = async () => {
  await initI18n();

  const container = document.getElementById('root');

  const root = createRoot(container!);

  root.render(<App />);
};
start();
//registerServiceWorker();
